import { Component } from "react";

import { Redirect, Route, Switch } from "react-router-dom";

import { withAuth0 } from "@auth0/auth0-react";
import { ReduxState } from "./types/redux";

import "./styles/index.scss";

import CompleteSignup from "./pages/CompleteSignup";
import Grocerize from "./pages/GrocerizeHome";
import ItemsHome from "./pages/ItemsHome";
import MyHome from "./pages/MyHome";
import PageList from "./components/pages/PageList";
import PageDetail from "./components/pages/PageDetail";

import Modal from "./components/modals/Modal";
import { routes } from "./utils/routes";

import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import ProtectedRoute from "./clients/auth/ProtectedRoute";
import { HttpClient } from "./clients/auth/addTokenToHTTPRequests";
import SignupPage from "./components/auth/SignupForm";
import VerifyEmail from "./components/auth/VerifyEmail";
import WelcomePage from "./components/auth/Welcome";
import MobileUserGuide from "./components/grocerize/GrocerizeUserGuideMobile";
// import Banner from "./components/notification/Banner";
import ContactUs from "./components/views/ContactUsView";
import FAQsView from "./components/views/FAQsView";
import LandingPage from "./pages/LandingPage";
import MaintenanceMode from "./pages/MaintenanceMode";
import Page404 from "./pages/Page404";
import PremiumPage from "./pages/PremiumPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import PublicListsPage from "./pages/PublicListsPage";
import SignUpTermsOfUse from "./pages/SignUpTermsOfUse";
import TermsOfUse from "./pages/TermsOfUse";
import { getCurrentBasket } from "./redux/actions/basketActions";
// Comment out missing imports for now
// import { loadBasket } from "./functions/basket/loadBasket";
// import { findListAndAddToBasket } from "./functions/lists/findListAndAddToBasket";
import { getCategoryTreeFromDB, initializeCategoryTree } from "./redux/actions/categoryAction";
import { getUserFavourites } from "./redux/actions/favouritesActions";
import { showModal } from "./redux/actions/modalActions";
import { getUserPriceAlerts } from "./redux/actions/priceAlertActions";
import { getUserData } from "./redux/actions/userActions";
import { fetchRecipesFromShopify } from "./redux/actions/recipeActions";
// Legacy recipe imports restored
import Recipe from "./pages/Recipe";
import Recipes from "./pages/Recipes";
import RecipeDetail from "./pages/RecipeDetail";
import Blogs from "./pages/Blogs";
import BlogDetail from "./pages/BlogDetail";
import UnlockPremiumModal from "./components/popups/UnlockPremiumModal";
import WelcomePremiumModal from "./components/popups/WelcomePremiumModal";

interface Props {
  getCategoryTreeFromDB: any;
  auth0: any;
  getCurrentBasket: any;
  getUserData: any;
  getUserFavourites: any;
  getUserPriceAlerts: any;
  showModal: any;
  basketItems?: ItemData[];
  modal?: ModalInputs;
  fetchRecipesFromShopify: any;
  initializeCategoryTree: any;
  user?: {
    isPremium?: boolean;
    [key: string]: any;
  };
}

interface State {
  correctMaintenancePassword: boolean;
  startTime: any;
  basketItems?: ItemData[];
  notifications: Notification[];
}

class App extends Component<Props, State> {
  state = {
    correctMaintenancePassword: false,
    startTime: moment().local(),
    basketItems: this.props.basketItems,
    notifications: [],
  };

  constructor(props: Props) {
    super(props);
    const { getAccessTokenSilently } = this.props.auth0;
    HttpClient.setTokenGenerator(() =>
      getAccessTokenSilently({ useRefreshTokens: true })
    );
  }

  componentDidMount = async () => {
    const WEBFLOW_PAGE_ID = "640ab55b97b40f94bc5cddbc";
    const WEBFLOW_SITE_ID = "63e101e0ed6570ca9e242473";

    var doc = document.getElementsByTagName("html")[0];
    doc.setAttribute("data-wf-page", WEBFLOW_PAGE_ID);
    doc.setAttribute("data-wf-site", WEBFLOW_SITE_ID);

    if (this.props.auth0.isAuthenticated) {
      await this.getUserProfileAndAssets();
      // Fetch the user's basket data from the backend
      await this.props.getCurrentBasket();
    }

    setInterval(this.checkTimeElapsed, 60000);

    // get the category tree data and product counts - using enhanced version
    // this will fetch & cache collection product counts
    this.props.initializeCategoryTree();
    
    // also fetch recipes to get the count
    this.props.fetchRecipesFromShopify('recipes');
    
    // Check for welcome_premium parameter to show welcome modal after checkout
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('welcome_premium') === 'true') {
      // Remove the parameter from URL to prevent showing modal on page refresh
      const newUrl = window.location.pathname + window.location.hash;
      window.history.replaceState({}, document.title, newUrl);
      
      // Show the welcome modal with the correct modal pattern
      const modalContent = () => <WelcomePremiumModal />;
      this.props.showModal({
        component: modalContent,
        position: 'centered',
      });
    }

    const { data } = await axios.get(
      process.env.REACT_APP_BACKEND_URL + "/notifications"
    );

    this.setState({ notifications: data });
  };

  manageItemsOnLocalStorage = async () => {
    // Commented out until we implement the missing functions
    // const itemsOnStorage = loadFromLocalStorage();
    // 
    // if (itemsOnStorage && itemsOnStorage.basketItems.length > 0) {
    //   await this.pushItemsToDB(itemsOnStorage.basketItems);
    // }
    // 
    // removeItemsOnStorage();
    console.log('manageItemsOnLocalStorage temporarily disabled');
  };

  checkTimeElapsed = () => {
    // Premium popup auto-display has been disabled
    // The original code below was commented out to prevent automatic popup display
    
    /*
    const currentTime = moment();
    const startTime = this.state.startTime;
    // calculate the elapsed time in seconds
    const elapsedSeconds = currentTime.diff(startTime, "seconds");

    // Check if user is not authenticated and not a premium user before showing the premium modal
    const isPremiumUser = this.props.auth0.isAuthenticated && 
                         this.props.user?.isPremium;

    if (
      !isPremiumUser && // Only show for non-premium users
      elapsedSeconds >= 60 &&
      this.props.modal?.status === "hidden"
    ) {
      const modalContent = () => <UnlockPremiumModal />;
      this.props.showModal({ component: modalContent });

      // Reset the start time for subsequent checks
      this.setState({ startTime: moment() });
    }
    */
  };

  pushItemsToDB = async (
    items: {
      id: number;
      quantity: number;
      selected_vendor_id?: number;
    }[]
  ) => {
    // Use Promise.all to wait for all requests to complete
    await Promise.all(items.map(
      async (item: {
        id: number;
        quantity: number;
        selected_vendor_id?: number;
      }) => {
        // Make a direct API call with replace_quantity flag to prevent duplicates
        await axios.patch(
          process.env.REACT_APP_BACKEND_URL + "/user/lists/current/item",
          {
            item_id: item.id,
            quantity: item.quantity,
            selected_vendor_id: item.selected_vendor_id,
            replace_quantity: true // Add this flag to tell the backend to replace the quantity
          },
          {
            headers: {
              Authorization: `Bearer ${await this.props.auth0.getAccessTokenSilently({ useRefreshTokens: true })}`
            }
          }
        );
        console.log(`Item ${item.id} added to cart with replace_quantity flag from App.tsx`);
      }
    ));
  };

  componentDidUpdate = async (prevProps: Props) => {
    // if user logins in get their details
    if (
      this.props.auth0.isAuthenticated !== prevProps.auth0.isAuthenticated &&
      this.props.auth0.isAuthenticated
    ) {
      await this.manageItemsOnLocalStorage();

      await this.getUserProfileAndAssets();
      await this.props.getCurrentBasket();
    }
  };

  getUserProfileAndAssets = async () => {
    await Promise.allSettled([
      this.props.getUserData(),
      this.props.getUserFavourites(),
      this.props.getUserPriceAlerts(),
    ]);
  };

  // For Mobile View Rendering
  render() {
    if (
      process.env.REACT_APP_MAINTENANCE_MODE_PASSWORD &&
      !this.state.correctMaintenancePassword
    ) {
      return (
        <MaintenanceMode
          onCorrectPassword={() =>
            this.setState({ correctMaintenancePassword: true })
          }
        />
      );
    }

    return (
      <div className="u-h--var--mobile u-w-all u-overflow--hidden u-h-all">
        <div id="banner">
          {/* Temporarily commented out notifications until we fix the Notification type */}
          {/* {this.state.notifications.map(function (notification: Notification) {
            return <Banner key={notification.id} notification={notification} />;
          })} */}
        </div>

        <Switch>
          <Route exact path={routes.landing} component={LandingPage} />
          <Route exact path={routes.default}>
            <Redirect to={routes.browse} />
          </Route>
          {/* Components */}
          <Route exact path={routes.signup} component={CompleteSignup} />
          <Route exact path={routes.verifyEmail} component={VerifyEmail} />
          <Route exact path={routes.signupForm} component={SignupPage} />
          <ProtectedRoute 
            exact 
            path={routes.checkout} 
            component={() => {
              // Dynamically import the CustomCheckout component
              const CustomCheckout = require('./components/checkout/CustomCheckout').default;
              return <CustomCheckout />;
            }} 
          />
          <Route exact path={routes.welcome} component={WelcomePage} />
          <Route
            exact
            path={routes.browse}
            component={ItemsHome}
          />
          <Route
            exact
            path={routes.mobileUserGuide}
            component={MobileUserGuide}
          />
          
          {/* Recipe routes need to be before browseWithCategories to avoid being caught by the wildcard */}
          <Route exact path="/browse/recipes" component={Recipe} />
          
          {/* Blog routes also need to be before browseWithCategories */}
          <Route exact path="/browse/blogs" component={Blogs} />
          <Route exact path="/browse/blogs/:handle" component={BlogDetail} />

          <Route
            exact
            path={routes.browseWithCategories}
            component={ItemsHome}
          />
          <Route exact path={routes.termsOfUse} component={TermsOfUse} />
          <Route
            exact
            path={routes.SignUpTermsOfUse}
            component={SignUpTermsOfUse}
          />
          <Route exact path={routes.privacyPolicy} component={PrivacyPolicy} />
          <Route exact path={routes.publicLists} component={PublicListsPage} />
          {/* Legacy recipe routes - restored */}
          <Route exact path={routes.recipe} component={Recipe} />
          
          {/* New Shopify blog recipe routes */}
          <Route exact path="/recipes" component={Recipes} />
          <Route exact path="/recipes/:handle" component={RecipeDetail} />
          
          <Route exact path={routes.contact} component={ContactUs} />
          <Route exact path={routes.notFound} component={Page404} />

          {/* Shopify Pages */}
          <Route exact path={routes.pages} component={PageList} />
          <Route exact path={routes.pageDetail} component={PageDetail} />

          {/* Must be logged in to view */}
          <Route exact path={routes.grocerize} component={Grocerize} />
          <Route exact path={routes.faqs} component={FAQsView} />
          <Route exact path={routes.premium} component={PremiumPage} />
          <ProtectedRoute path={routes.my} component={MyHome} exact={true} />

          {/* send unknown routes to home */}
          <Redirect to={routes.notFound} />
        </Switch>
        <Modal />
      </div>
    );
  }
}

// Define correct item data type for type-safety
interface ItemData {
  id: string;
  quantity: number;
  [key: string]: any;
}

interface ModalInputs {
  modalType: string;
  modalProps?: any;
  status?: string;
}

interface Notification {
  id: string;
  [key: string]: any;
}

const mapStateToProps = (state: ReduxState) => ({
  // Safely access basket items with optional chaining
  basketItems: state.basket?.basketItems as ItemData[] | undefined,
  modal: state.modal as ModalInputs | undefined,
  user: state.user,
});

export default withAuth0<any>(
  connect(mapStateToProps, {
    getCategoryTreeFromDB,
    getCurrentBasket,
    getUserData,
    getUserPriceAlerts,
    getUserFavourites,
    showModal,
    fetchRecipesFromShopify,
    initializeCategoryTree,
  })(App)
);
